import Api, { makeApiGenerator } from 'domain/api';
import { fetchOtherArtistWorksListAction } from 'domain/otherArtistWorks/otherArtistWorksActions';

export const fetchOtherArtistWorksList_apiGen = makeApiGenerator({
  api: Api.getArtworkList,
  actionCreator: fetchOtherArtistWorksListAction,
});
